"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_ORI_EVENTS_USER_ACTION = void 0;
exports.initUserActionEvents = initUserActionEvents;
var _userAction = require("@ori-events/user-action");
const DATA_ORI_EVENTS_USER_ACTION = exports.DATA_ORI_EVENTS_USER_ACTION = '[data-ori-events-user-action]';
function initUserActionEvents() {
  const links = [...document.querySelectorAll(DATA_ORI_EVENTS_USER_ACTION)];
  links.forEach(link => {
    if (link.dataset.isUserActionInitialized) {
      return;
    }
    link.addEventListener('click', () => {
      const {
        oriEventsUserAction
      } = link.dataset;
      if (!oriEventsUserAction) {
        return;
      }
      const {
        metaHierarchy,
        numberValue
      } = JSON.parse(oriEventsUserAction);
      (0, _userAction.dispatch)(metaHierarchy, numberValue);
    });
    // eslint-disable-next-line no-param-reassign -- x
    link.dataset.isUserActionInitialized = '1';
  });
}